import React, { useState, useEffect } from "react";
import { db, } from "../../services/firebaseConfig";
import { collection, getDocs, query, where } from "firebase/firestore";
import "../../styles/ProfitByDistrict.css";

const ProfitByDistrict = () => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const userRole = storedUser?.role;
    const userDistrict = storedUser?.district;
    const [compiledOrders, setCompiledOrders] = useState([]);
    const [profitsByDistrict, setProfitsByDistrict] = useState({});
    const [expandedDistricts, setExpandedDistricts] = useState([]);
    const [prices, setPrices] = useState({});


    const toNumberSafe = (v) => {
        if (v == null) return 0;

        // qty object: {total, ordered, qty}
        if (typeof v === "object") {
            const n = Number(v.total ?? v.ordered ?? v.qty ?? 0);
            return Number.isFinite(n) ? n : 0;
        }

        // qty string (kalau pernah jadi "12 unit")
        if (typeof v === "string") {
            const m = v.match(/-?\d+(\.\d+)?/);
            const n = m ? Number(m[0]) : 0;
            return Number.isFinite(n) ? n : 0;
        }

        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };

    const formatRM = (n) =>
        new Intl.NumberFormat("ms-MY", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(n || 0));



    useEffect(() => {
        const fetchPrices = async () => {
            const snapshot = await getDocs(collection(db, "inventori", "selangor", "stocks"));
            const data = {};
            snapshot.forEach((docSnap) => {
                const stock = docSnap.data();
                const itemName = stock.name || stock.category || "Unknown";
                data[itemName] = stock.harga;

                console.log("itemName", itemName);
                console.log("✅ harga pengerusi:", stock.harga?.pengerusi); // Ini betul
            });
            setPrices(data);

        };

        fetchPrices();
    }, []);

    useEffect(() => {
        const fetchCompiledOrders = async () => {
            try {
                const q = userRole === "pengarah"
                    ? query(collection(db, "inventori", "selangor", "compiledOrders"))
                    : query(
                        collection(db, "inventori", "selangor", "compiledOrders"),
                        where("district", "==", userDistrict)
                    );

                const snapshot = await getDocs(q);
                const data = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                console.log("📦 compiledOrders fetched:", data); // 👈 Tambah sini


                setCompiledOrders(data);
            } catch (error) {
                console.error("❌ Gagal dapatkan data compiledOrders:", error);
            }
        };

        if (userRole === "pengarah" || (userRole && userDistrict)) {
            fetchCompiledOrders();
        }

    }, [userRole, userDistrict]);


    useEffect(() => {
        const districtProfits = {};

        compiledOrders.forEach((order) => {
            const role = "pengerusi";
            let orderProfit = 0;

            Object.entries(order.items || {}).forEach(([category, items]) => {
                Object.entries(items || {}).forEach(([itemName, details]) => {
                    // ✅ baju (ikut size)
                    if (category === "baju" && prices[itemName] && typeof details === "object") {
                        Object.entries(details).forEach(([size, qtyObj]) => {
                            const price = toNumberSafe(prices[itemName]?.[size]?.[role]);
                            const qty = toNumberSafe(qtyObj);
                            orderProfit += price * qty;
                        });
                        return;
                    }

                    // ✅ selain baju (flat ikut role)
                    const price = toNumberSafe(prices[itemName]?.[role]);

                    if (typeof details === "object") {
                        Object.values(details).forEach((qtyObj) => {
                            const qty = toNumberSafe(qtyObj);
                            orderProfit += price * qty;
                        });
                    } else {
                        orderProfit += price * toNumberSafe(details);
                    }
                });
            });

            const district = order.district || "Unknown";
            if (!districtProfits[district]) districtProfits[district] = [];

            districtProfits[district].push({
                id: order.id,
                date: order.orderDate?.toDate?.().toLocaleDateString("ms-MY") || "-",
                pengerusi: order.pengerusiName || "-",
                profit: toNumberSafe(orderProfit), // ✅ pastikan bukan NaN
            });
        });

        setProfitsByDistrict(districtProfits);
    }, [compiledOrders, prices]);


    const toggleDistrict = (district) => {
        setExpandedDistricts((prev) =>
            prev.includes(district) ? prev.filter((d) => d !== district) : [...prev, district]
        );
    };

    const totalProfit = Object.values(profitsByDistrict).flat().reduce((sum, order) => sum + order.profit, 0);

    return (
        <div className="profit-report-container">
            <h2>
                {userRole === "pengarah"
                    ? "Laporan Kewangan Mengikut Kawasan"
                    : `Laporan Kewangan : ${userDistrict}`}
            </h2>

            <p className="total-profit">
                <strong>Jumlah Untung Keseluruhan:</strong> RM {formatRM(totalProfit)}
            </p>

            <div className="district-summary">
                <table>
                    <thead>
                        <tr>
                            <th>Kawasan</th>
                            <th>Jumlah Untung (RM)</th>
                            <th>Lihat Butiran</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(profitsByDistrict).map(([district, orders]) => {
                            const districtTotal = orders.reduce((sum, o) => sum + o.profit, 0);
                            return (
                                <tr key={district}>
                                    <td>{district}</td>
                                    <td>RM {formatRM(districtTotal)}</td>
                                    <td>
                                        <button onClick={() => toggleDistrict(district)}>
                                            {expandedDistricts.includes(district) ? "Sembunyi" : "Lihat"}
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {expandedDistricts.map((district) => (
                <div key={district} className="district-details">
                    <h3>{district}</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Tarikh</th>
                                <th>Pengerusi</th>
                                <th>Untung Tempahan (RM)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {profitsByDistrict[district].map((order) => (
                                <tr key={order.id}>
                                    <td>{order.date}</td>
                                    <td>{order.pengerusi}</td>
                                    <td>RM {formatRM(order.profit)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
};

export default ProfitByDistrict;